import React from "react";
import { Link } from "react-router-dom";
import { surahs } from "../data/surahs"; // import surah data

function SurahListPage() {
  return (
    <div className="p-6">
      <h2 className="text-3xl font-bold text-center text-blue-700 mb-6">
        List of Surahs
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {surahs.map((surah) => (
          <div
            key={surah.id}
            className="p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
          >
            <Link
              to={`/lessons/surahs/${surah.id}`} // Link to specific Surah page
              className="block text-center text-2xl font-semibold text-blue-700 hover:text-blue-500"
            >
              {surah.name}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SurahListPage;
